import { ESTADO_COLOR, ESTADO_LABEL } from "../lib/constants";

export default function EstadoBadge({ estado, size = "sm" }) {
  const cfg = ESTADO_COLOR[estado] || ESTADO_COLOR.vencido;
  const label = ESTADO_LABEL[estado] || estado;
  const sizeCls = size === "lg" ? "text-sm px-3 py-1.5" : "text-xs px-2.5 py-1";
  return (
    <span
      className={`inline-flex items-center gap-1.5 border ${cfg.bg} ${cfg.border} ${cfg.text} font-medium rounded-full ${sizeCls}`}
      data-testid={`estado-badge-${estado}`}
    >
      <span className={`status-dot ${estado}`} style={{ background: cfg.hex }}></span>
      {label}
    </span>
  );
}
